<template>
  <div class="coverage-row d-flex align-center">
    <div class="coverage-slots d-flex" style="gap: 5px">
      <div
        v-for="(slot, index) in anticipationSlots"
        :key="slot.id"
        class="coverage-slot d-flex align-center justify-center flex-wrap"
      >
        <span
          v-for="dot in coverage[index]"
          :key="dot.ruleId"
          class="coverage-dot d-inline-block rounded-circle"
          :style="{ backgroundColor: dot.color }"
        ></span>
      </div>
    </div>
    <div class="coverage-controls-spacer"></div>
  </div>
</template>

<script>
export default {
  name: "a-pricing-strategy-grid-rules-coverage",
  props: {
    anticipationSlots: {
      type: Array,
      required: true
    },
    coverage: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped lang="scss">
.coverage-row {
  padding: 0 10px;
  margin-bottom: 10px;
}
.coverage-slots {
  flex: 1;
}
.coverage-slot {
  flex: 1;
}
.coverage-controls-spacer {
  width: 40px;
}
.coverage-dot {
  width: 8px;
  height: 8px;
  margin: 1px;
}
</style>
